import React, { useCallback, useState } from 'react'
import { Stack, TextField, Card, FormControl } from '@mui/material'
import Modal from '@/components/Modal'
import Button from '@/components/Button'
import Text from '@/components/Text'
import { FlexRow } from './components'
import ClearIcon from '@mui/icons-material/Clear'
import Select from '@/components/Select'
import { LoadingButton } from '@/components/Button'
import { GenerateShareCodeInfo } from '@/types'
import { useQuery, useMutation } from '@tanstack/react-query'
import { getApplications, generateShareCode } from '@/api'
import { Message } from '@cx/ui'

export interface GenerateShareCodeProps {
  open: boolean
  onClose: () => void
  refetch: () => void
}

const GenerateShareCode: React.FC<GenerateShareCodeProps> = (props) => {
  const { open, onClose, refetch } = props
  const [formValue, setFormValue] = useState<GenerateShareCodeInfo>({
    // @ts-ignore
    app_id: null,
    remark: '',
  })

  const { data: market } = useQuery(['getApplications'], getApplications, {})

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  const generateCode = useMutation(generateShareCode, {
    onSuccess: () => {
      handleClose()
      Message.success('分享链接已生成')
      refetch()
      setFormValue({
        // @ts-ignore
        app_id: null,
        remark: '',
      })
    },
  })

  const handleUpdateAppId = useCallback((app_id: number) => {
    setFormValue((formValue) => ({ ...formValue, app_id }))
  }, [])

  const handleChangeRemark = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const remark = event?.target?.value
    setFormValue((formValue) => ({ ...formValue, remark }))
  }, [])

  const handleGenerate = useCallback(() => {
    if (formValue?.app_id) {
      generateCode.mutate(formValue)
    }
  }, [generateCode, formValue])

  return (
    <Modal width={'500px'} open={open} onClose={handleClose}>
      <Card sx={{ padding: '24px' }}>
        <Stack sx={{ gap: '16px' }}>
          <FlexRow sx={{ justifyContent: 'space-between' }}>
            <Text>生成分享链接</Text>
            <ClearIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
          </FlexRow>
          <Stack sx={{ gap: '8px' }}>
            <FormControl key='config-app-name' margin='dense'>
              <Select
                label={'产品应用'}
                empty={'暂无产品'}
                required={true}
                value={formValue.app_id > 0 ? formValue.app_id : ''}
                // @ts-ignore
                onChange={handleUpdateAppId}
                options={
                  market?.data
                    ? market?.data?.map((pd) => ({
                        label: pd.name,
                        value: pd.id,
                      }))
                    : []
                }
              />
            </FormControl>
            <FormControl sx={{ width: '100%' }}>
              <TextField
                key='remark'
                fullWidth={true}
                label={'备注'}
                value={formValue?.remark ?? ''}
                onChange={handleChangeRemark}
              />
            </FormControl>
          </Stack>

          <FlexRow sx={{ justifyContent: 'flex-end' }}>
            <Button type='text' onClick={handleClose}>
              取消
            </Button>
            <LoadingButton
              loading={generateCode.isLoading}
              disabled={!formValue?.app_id}
              buttonStyle={{
                width: '100%',
                fontSize: '16px',
              }}
              onClick={handleGenerate}
            >
              生成分享链接
            </LoadingButton>
          </FlexRow>
        </Stack>
      </Card>
    </Modal>
  )
}

export default GenerateShareCode
